import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import axios from "axios";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import {
  SetItemsSelected,
  NotificatioErrController,
  NotificatioSucController,
  // CheckConfirmPassword,
} from "../../../helpers/Utils";import createSocket from "../../../helpers/createSocket";
import { ContentForm } from "../../../containers/pages/user-role";
import {
  Add,
  Update,
  PageHeading,
  Pagination,
} from "../../../containers/pages/general";
// import ListItemLeftForm from '../../../containers/pages/ListItemLeftForm';
import LogsHelper from "../../../helpers/Logs";
// import PasswordBox from '../../../components/PasswordBox'
import IntlMessages from "../../../helpers/IntlMessages";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";
import ContentDisplay from "../../../containers/pages/user-role/ContentDisplay";
import { isD, isU } from "../../../helpers/Roles";
import ListItemFormMobile from "../../../containers/pages/user-role/ListItemFormMobile";
import AddUserRole from "../../../containers/pages/user-role/AddUserRole";
import UpdateUserRole from "../../../containers/pages/user-role/UpdateUserRole";
import ListItemLeftForm from "../../../containers/pages/user-role/ListItemLeftForm";

const DEFAULT_FORM = {
  id: "",
  name: "",
  email: "",
  username: "",
  password: "",
  repassword: "",
  user_role_id: "",
  staff_id: null, // Selected staff { value, label } or null
  newStaffName: "", // New staff name if creating
};

const ROLE_ALIAS = "user_role";

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: {
        pageSizes: [12, 24],
        selectedPageSize: 12,
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
        search: "",
      },
      selectedItems: [],
      data: [],
      data_user_roles: [],
      staffList: [], // Staff list for dropdown
      is_loading_data: true,
      show: {
        add: false,
        update: false,
        view: false,
        viewonly: false,
      },
      accordion: [],
      form: DEFAULT_FORM,

      // password
      // password: "",
      // isOpenModalPassword: false,
      // passwordFuncCallback: null,
    };

    this.socket = createSocket();
  }

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    this.dataListRender();
    this.dataUserRoleListRender();
    this.fetchStaffList();
  }

  /** Axios func helper */
  dataListRender = () => {
    const { selectedPageSize, currentPage, search } = this.state.page;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(
        `${
          END_POINT + "/user-role/grant/json"
        }?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        let anyAccordion = [];
        let numeroPerguntas = data.data.length;
        for (var i = 0; i < numeroPerguntas; i++) {
          // if (!i) {
          //     anyAccordion.push(true);
          // }
          anyAccordion.push(false);
        }
        this.setState(
          (prev) => ({
            ...prev,
            data: data.data,
            is_loading_data: false,
            page: {
              ...prev.page,
              totalPage: data.totalPage,
              totalItem: data.totalItem,
            },
            accordion: anyAccordion,
          }),
          () => {
            if (this.state.form.id) {
              const { id, name, username, email, user_role_id } =
                this.state.form;
              this.setState((prev) => ({
                ...prev,
                form: {
                  ...prev.form,
                  id,
                  name,
                  username,
                  email,
                  user_role_id,
                },
              }));
            } else {
              this.setState((prev) => ({
                ...prev,
                selectedItems: [],
                show: {
                  ...prev.show,
                  update: false,
                },
                form: DEFAULT_FORM,
              }));
            }
          },
        );
      })
      .catch((err) => {
        const errorMessage =
          err.response?.data?.responseText ||
          "Có lỗi xảy ra, vui lòng thử lại.";
        NotificatioErrController(errorMessage);
        this.setState({ is_loading_data: false });
        return false;
      });
  };

  dataUserRoleListRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/user-role`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_user_roles: data.data,
        }));
      })
      .catch((err) => {
        const errorMessage =
          err.response?.data?.responseText ||
          "Có lỗi xảy ra, vui lòng thử lại.";
        NotificatioErrController(errorMessage);
        return false;
      });
  };

  fetchStaffList = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/user-staff/all-simple`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          staffList: data.data || [],
        }));
      })
      .catch((err) => {
        console.log("Error fetching staff list:", err);
      });
  };

  onHandlerDelete = () => {
    // let domain = (window.location.host).split('.')[0];
    // if (domain !== "demo") {
    //   // confirm password
    //   if (this.state.password === "") {
    //     this.setState({
    //       passwordFuncCallback: this.onHandlerDelete,
    //       isOpenModalPassword: true,
    //     });
    //     return false;
    //   } else {
    //     this.setState({
    //       password: "",
    //       isOpenModalPassword: false,
    //     });
    //   }
    // }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .delete(`${END_POINT + "/user-role/grant"}`, {
        data: {
          arrayId: this.state.selectedItems,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["user-role-delete"],
        });

        this.dataListRender();
      })
      .catch((err) => {
        const errorMessage =
          err.response?.data?.responseText ||
          "Có lỗi xảy ra, vui lòng thử lại.";
        NotificatioErrController(errorMessage);
        return false;
      });
  };

  onHandlerUpdate = (e) => {
    e.preventDefault();
    const { id, name, username, email, password, repassword, user_role_id } =
      this.state.form;

    if (!name || !id || !username || !user_role_id) {
      NotificatioErrController("Dữ liệu không hợp lệ");
      return;
    }

    if (password !== repassword) {
      NotificatioErrController("Mật khẩu không khớp nhau");
      return;
    }

    if (password !== "" && repassword !== "" && password.length <= 5) {
      NotificatioErrController("Mật khẩu tối thiểu 5 ký tự");
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/user-role/grant"}`,
        {
          id,
          fullname: name,
          username,
          email,
          password,
          repassword,
          user_role_id: user_role_id.value,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["user-role-update"],
        });

        this.dataListRender();
        this.toggle("update");
      })
      .catch((err) => {
        const errorMessage =
          err.response?.data?.responseText ||
          "Có lỗi xảy ra, vui lòng thử lại.";
        NotificatioErrController(errorMessage);
        return false;
      });
  };

  onHandlerAdd = (e) => {
    e.preventDefault();
    const {
      name,
      username,
      email,
      password,
      repassword,
      user_role_id,
      staff_id,
      newStaffName,
    } = this.state.form;

    // Chỉ tạo nhân viên khi user chủ động chọn "+ Tạo nhân viên mới"
    let staffName = "";
    let shouldCreateNewStaff = false;

    if (staff_id) {
      if (staff_id.value === "new") {
        // Tạo nhân viên mới với tên đã nhập
        staffName = newStaffName || "";
        shouldCreateNewStaff = true;
        if (!staffName) {
          NotificatioErrController("Tên nhân viên mới cần được nhập vào");
          return;
        }
      } else {
        // Liên kết nhân viên hiện có
        staffName = staff_id.name || staff_id.label || "";
      }
    }
    // Không chọn staff → chỉ tạo tài khoản, không tạo nhân viên (shouldCreateNewStaff = false)

    if (!username) {
      NotificatioErrController("Tên đăng nhập cần được thêm vào");
      return;
    }
    if (!password) {
      NotificatioErrController("Mật khẩu cần được thêm vào");
      return;
    }
    if (!user_role_id) {
      NotificatioErrController("Phân quyền cần được chọn");
      return;
    }

    if (password !== repassword) {
      NotificatioErrController("Mật khẩu không khớp nhau");
      return;
    }

    if (password !== "" && repassword !== "" && password.length <= 5) {
      NotificatioErrController("Mật khẩu tối thiểu 5 ký tự");
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT + "/auth/signup/role"}`,
        {
          fullname: staffName || username,
          username,
          email,
          password,
          repassword,
          user_role_id: user_role_id.value,
          domain:
            localStorage.getItem("vmass_store_domain") ||
            window.location.host.split(".")[0],
          staff_id: !shouldCreateNewStaff && staff_id ? staff_id.value : null,
          newStaffName: shouldCreateNewStaff ? staffName : null,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["user-role-create"],
        });

        this.dataListRender();
        this.fetchStaffList();
        this.setState((prev) => ({
          ...prev,
          form: DEFAULT_FORM,
        }));
      })
      .catch((err) => {
        const errorMessage =
          err.response?.data?.responseText ||
          "Có lỗi xảy ra, vui lòng thử lại.";
        NotificatioErrController(errorMessage);
        return false;
      });
  };
  /** Axios func helper */

  /** State func helper */
  toggle = (name) => {
    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: name === "add" ? false : prev.show.update,
        view: name === "add" ? false : prev.show.view,
        [name]: !prev.show[name],
      },
      selectedItems: name === "add" ? [] : prev.selectedItems,
      form: name === "add" ? DEFAULT_FORM : prev.form,
    }));
  };

  onChangeForm = (e, _name) => {
    if (e && e.target) {
      let {
        target: { name, value },
      } = e;
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [name]: value,
        },
      }));
    } else {
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [_name]: e,
        },
      }));
    }
  };

  onSubmitForm = (type) => {
    if (type === "update") {
      this.onHandlerUpdate();
    } else if (type === "add") {
      this.onHandlerAdd();
    }
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          currentPage: page,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onSearchKey = (e) => {
    if (!e) return false;

    if (e.target) {
      let {
        target: { value },
      } = e;
      let v = value;
      if (value === undefined) {
        v = e.target.firstElementChild.value; // parent to child

        //     value = v.toLowerCase();
        //     this.setState(
        //         (prev) => ({
        //             ...prev,
        //             page: {
        //                 ...prev.page,
        //                 search: value,
        //             },
        //         }),
        //         () => this.dataListRender()
        //     );
        // } else {
        //     value = value.toLowerCase();
        //     this.setState(
        //         (prev) => ({
        //             ...prev,
        //             page: {
        //                 ...prev.page,
        //                 search: value,
        //             },
        //         }),
        //         () => this.dataListRender()
        //     );
      }
    }

    if (e.key === "Enter") {
      let value = e.target.value.toLowerCase();
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: value,
          },
        }),
        () => this.dataListRender(),
      );
    }
  };

  onChangePageSize = (size) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          selectedPageSize: size,
          currentPage: 1,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onClickedItem = (item, callback, args) => {
    // Open update modal when clicking on card
    const { id, name, username, email, user_role_id } = item;

    this.setState(
      (prev) => ({
        ...prev,
        show: {
          ...prev.show,
          update: true,
          view: true,
          viewonly: false,
        },
        form: {
          ...prev.form,
          id,
          name,
          username,
          email,
          user_role_id,
        },
        selectedItems: [item.id],
      }),
      () => {
        if (callback) callback(args[0], args[1], args[2]);
      },
    );
  };

  onClickedUpdate = (item) => {
    const { id, name, username, email, user_role_id } = item;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: true,
      },
      form: {
        ...prev.form,
        id,
        name,
        username,
        email,
        user_role_id,
      },
      selectedItems: [item.id],
    }));
  };

  onClickedDelete = (item) => {
    let selectedSet = SetItemsSelected(
      item.id,
      this.state.selectedItems,
      "require",
    );
    if (window.confirm("Bạn chắc chắn muốn xoá tài khoản này?")) {
      this.setState(
        (prev) => ({
          ...prev,
          selectedItems: selectedSet,
        }),
        () => this.onHandlerDelete(),
      );
    }
  };

  onClickedCheckbox = (id, event) => {
    // Toggle multi-select
    let selectedSet = SetItemsSelected(id, this.state.selectedItems);

    this.setState((prev) => ({
      ...prev,
      selectedItems: selectedSet,
    }));
  };
  /** State func helper */

  toggleAccordion = (tab) => {
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    this.setState({
      accordion: state,
    });
  };

  render() {
    const { match } = this.props;
    const {
      page,
      selectedItems,
      data,
      data_user_roles,
      is_loading_data,
      show,
      form,
      accordion,
    } = this.state;

    // console.log('form: ', form);

    return is_loading_data ? (
      <div className="loading" />
    ) : (
      <div className="disable-text-selection">
        <PageHeading
          heading="analytics.user-role"
          setting={page}
          match={match}
          totalItem={page.totalItem}
          toggleFunc={() => {
            this.toggle("add");
          }}
          changePageSizeFunc={this.onChangePageSize}
          onSearchKeyFunc={this.onSearchKey}
          selectedItemsLength={selectedItems.length}
          onHandlerDelete={() => {
            if (window.confirm("Bạn có chắc chắn muốn xóa bản ghi này?")) {
              this.onHandlerDelete();
            }
          }}
          showExport={false}
        />
        <AddUserRole
          title={<IntlMessages id="user-role.add-new-modal-title" />}
          isOpen={show.add}
          toggle={() => {
            this.toggle("add");
          }}
          user_roles={data_user_roles}
          staffList={this.state.staffList}
          values={form}
          setting={show}
          onChange={this.onChangeForm}
          onSubmit={this.onHandlerAdd}
        >
          <ContentForm />
        </AddUserRole>
        <UpdateUserRole
          title={<IntlMessages id="user-role.title" />}
          isOpen={show.update}
          toggle={() => this.toggle("update")}
          setting={show}
          user_roles={data_user_roles}
          values={form}
          onChange={this.onChangeForm}
          onSubmit={this.onHandlerUpdate}
        />
        {data.length === 0 ? (
          <Card>
            <CardBody>Chưa có dữ liệu...</CardBody>
          </Card>
        ) : (
          <>
            <Row className="content-page__row d-none d-md-flex">
              <Col
                xs="12"
                sm="12"
                md="12"
                lg={show.view ? 4 : 12}
                xl={show.view ? 4 : 12}
              >
                {data.map((item, idx) => (
                  <ListItemLeftForm
                    onClickedItem={this.onClickedItem}
                    onUpdate={this.onClickedUpdate}
                    onDelete={this.onClickedDelete}
                    onChangeCheckbox={this.onClickedCheckbox}
                    selectedItems={selectedItems}
                    key={idx}
                    idx={idx}
                    item={item}
                  />
                ))}
                <Pagination
                  currentPage={page.currentPage}
                  totalPage={page.totalPage}
                  onChangePage={(i) => this.onChangePage(i)}
                />
              </Col>
              {show.view ? (
                <Col xs="12" sm="12" md="12" lg="8" xl="8">
                  <ContentDisplay values={form} />
                </Col>
              ) : null}
            </Row>
            <Row className="content-page__row d-block d-md-none mb-4">
              <Col>
                {data.map((item, idx) => {
                  // console.log(item);
                  return (
                    <div className="d-flex mb-3 card" key={item.id}>
                      <ListItemFormMobile
                        onClickedItem={this.onClickedItem}
                        onUpdate={this.onClickedUpdate}
                        onDelete={this.onClickedDelete}
                        onChangeCheckbox={this.onClickedCheckbox}
                        isDisabledUpdate={!isU(ROLE_ALIAS)}
                        isDisabledDelete={!isD(ROLE_ALIAS)}
                        selectedItems={selectedItems}
                        key={idx}
                        idx={idx}
                        item={item}
                        form={form}
                        accordion={accordion}
                        toggleAccordion={this.toggleAccordion}
                      />
                    </div>
                  );
                })}
                <Pagination
                  currentPage={page.currentPage}
                  totalPage={page.totalPage}
                  onChangePage={(i) => this.onChangePage(i)}
                />
              </Col>
            </Row>
          </>
        )}
      </div>
    );
  }
}

export default ContentComponent;
